<template>
<!--
  Local URL: http://localhost:8080/vd-fileupload-detail/<int: ID> where ID is the ID of the uploaded file object.
  Required Group Membership: Curator or Admin
  Purpose: This page is for members of the Curators group. It first compares the file with the CURRENT state of the 
  database as opposed to the state of the database when the file was uploaded. This process can take a little bit to 
  complete.
  When it finishes, the page displays the details of the file including what the data looks like according to the 
  system. This gives the curator the opportunity download the file (if desired) to review it before accepting it into 
  the database. Of course, if the curator identifies a problem with the data, they can reject the file also.
-->
    <VDBaseTemplate>
    <b-modal
      id="file_working-modal"
      v-model="showFileModal"
      centered
      scrollable
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      title="Getting File"
      :header-text-variant="'light'">
      Working on file. Please wait...
    <b-button class="mt-3" block @click="showFileModal = !showFileModal">OK</b-button>
    </b-modal>
      <b-modal
        id="api-err-modal"
        v-model="apiErrModalShow"
        centered
        scrollable
        hide-footer
        hide-header-close
        no-close-on-backdrop
        no-close-on-esc
        title="Error"
        :header-bg-variant="'warning'"
        :header-text-variant="'light'">
        <span v-html="err_msg"></span>
        <b-button class="mt-3" block @click="hideModal">OK</b-button>
      </b-modal>
      <!-- This modal shows to confirm commiting dataset. -->
      <b-modal
          id="confirm-commit-modal"
          v-model="confirmCommitModalShow"
          centered
          scrollable
          hide-footer
          hide-header-close
          no-close-on-backdrop
          no-close-on-esc
          title="Confirm Commit"
          :header-bg-variant="'warning'"
          :header-text-variant="'light'">
          <span v-html="confirmMessage"></span>
          <b-button class="mt-3" variant="success" @click="onCommit(); hideConfirmCommitModal()" block>Commit File</b-button>
          <b-button class="mt-3" @click="hideConfirmCommitModal" block>Cancel</b-button>
      </b-modal>
      <!-- This modal shows while the dataset is being deleted. -->
      <b-modal
        id="warning-modal"
        v-model="workingModalShow"
        centered
        scrollable
        hide-footer
        hide-header-close
        no-close-on-backdrop
        no-close-on-esc
        title="Evaluating File"
        :header-bg-variant="'warning'"
        :header-text-variant="'light'">
        <span v-html="'Comparing the selected file with the current data. This may take several minutes.'"></span>
      </b-modal>
      <!-- This modal shows to confirm rollback. -->
      <b-modal
          id="confirm-rollback-modal"
          v-model="confirmRollbackModalShow"
          centered
          scrollable
          hide-footer
          hide-header-close
          no-close-on-backdrop
          no-close-on-esc
          title="Confirm Rollback"
          :header-bg-variant="'warning'"
          :header-text-variant="'light'">
          <span v-html="'Are you sure you want to rollback this file upload? This action cannot be undone.'"></span>
          <b-button class="mt-3" variant="warning" @click="executeRollback(); hideConfirmRollbackModal()" block>Rollback</b-button>
          <b-button class="mt-3" @click="hideConfirmRollbackModal" block>Cancel</b-button>
      </b-modal>
      <!-- This modal shows while the rollback is in progress. -->
      <b-modal
        id="rollback-working-modal"
        v-model="rollbackWorkingModalShow"
        centered
        scrollable
        hide-footer
        hide-header-close
        no-close-on-backdrop
        no-close-on-esc
        title="Rolling Back"
        :header-bg-variant="'warning'"
        :header-text-variant="'light'">
        <span v-html="'Please wait while the rollback is processed. This may take several minutes.'"></span>
      </b-modal>
      <div class="w-100 h-100">
        <b-container fluid style="padding-right: 50px; padding-left: 50px;" class="pt-2 mt-2">
          <div class="title-area">
            <center>
              <br><br><br>
              <img
                src="@/assets/images/logos/vecdyn_logo.svg"
                class="mr-2"
                width=45px
              />
              <h2>Curate VecDyn File Upload Detail</h2>
            </center>
          </div>
          <b-button v-b-toggle.collapse-instructions variant="primary">Instructions</b-button>
          <b-collapse id="collapse-instructions">
            <div style="padding:15px;">
              <p><b>Curating Files</b></p>
              <p>Approve or Reject this file.</p>
            </div>
          </b-collapse>
          <hr />
          <!-- FILE DETAIL SECTION -->
          <b-row><b-col><b>File Name:</b> {{ file_name }}</b-col></b-row>
          <b-row><b-col><b>File ID:</b> {{ id }}</b-col></b-row>
          <b-row><b-col><b>File Uploader:</b> {{ uploader }}</b-col></b-row>
          <b-row><b-col><b>File Status:</b> {{ status }}</b-col></b-row>
          <b-button variant="primary" @click="downloadFile" size=sm>Download File</b-button>
          <b-row><b-col><b>Notes:</b></b-col></b-row>
          <b-row>
            <b-col cols="12" class="mt-1"> 
              <b-form-textarea id="file-notes-textarea" v-model="notes"></b-form-textarea>
              <b-button style="float: right;" class="ml-1 mt-1" @click="updateNotes()" variant="primary" size=sm>
                Update Notes
              </b-button>
            </b-col>
          </b-row>
          </b-container>
          <!-- ERROR SECTION -->
          <b-container fluid style="padding-right: 50px; padding-left: 50px;" v-if="error_list.length > 0" >
            <h3>Errors:</h3>
            <!-- <VBUploadObjectsTable :tableData="error_list" :objectName="'Error'" :type="'error'"/> -->
            <VBUploadObjectsContinuousTable :tableData="error_list" :objectName="'Error'" :type="'error'"/>
            <b-row style="margin-bottom: 1rem;">
              <b-col>
                <div style="float: right; display: inline;">
                  <b-button @click="clearPageState()">Cancel</b-button>
                </div>
              </b-col>
            </b-row>
          </b-container>

        <!-- SUMMARY SECTION -->
        <b-container fluid style="padding-right: 50px; padding-left: 50px;" v-if="show_summary">
          <!-- <h3>Summary:</h3> -->
          <b-row><b-col><b>Total CSV rows:</b> {{ summary.csv_rows }}</b-col></b-row>
          <!-- <b-row><b-col><b>New rows:</b> {{ summary.new_rows }}</b-col></b-row> -->
          <!-- <b-row><b-col><b>New rows in existing datasets:</b> {{ summary.new_rows_existing_datasets }}</b-col></b-row> -->
          <!-- <b-row><b-col><b>Rows already in database:</b> {{ summary.existing_rows }}</b-col></b-row> -->
          <b-row v-if="summary.duplicate_rows > 0" style="color: red;"><b-col><b>Duplicate rows found in file:</b> {{ summary.duplicate_rows }}</b-col></b-row>
          <b-row><b-col><b>Total Datasets in CSV:</b> {{ summary.csv_datasets }}</b-col></b-row>
          <!-- <b-row><b-col><b>New datasets in CSV:</b> {{ summary.new_datasets.join(', ') }}</b-col></b-row> -->
          <!-- <b-row><b-col><b>New datasets in CSV:</b> {{ summary.new_dataset_count }}</b-col></b-row> -->
            <span v-if="summary.unknown_columns.length">
              <b-row style="color: red;">
                <b-col>
                  <b>Unrecognized columns in the file that will not be processed:</b> <br>
                  {{ summary.unknown_columns.join(', ') }}
                </b-col>
              </b-row>
          </span>
          <b-row>
            <!-- <b-col>
              <h3 style="position: absolute; bottom: 0px; cursor: pointer;">Row Data Summary:</h3>
            </b-col>
            <b-col>
              <b-row>
                  <b-col>
                    <div  style="float: right;">
                      New Row: 
                      <div class="color-box" style="background-color: #c3e6cb; border-color: #8fd19e;"></div>
                    </div>
                  </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div  style="float: right;">
                    New Row in Exising Dataset: 
                    <div class="color-box" style="background-color: #ffeeba; border-color: #ffdf7e;"></div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div  style="float: right;">
                    Row Already in Database: 
                    <div class="color-box" style="background-color: #f1b0b7; border-color: #8fd19e;"></div>
                  </div>
                </b-col>
              </b-row>
            </b-col> -->
            <!-- <VBUploadObjectsContinuousTable :tableData="cptItems" :objectName="'Row Data Summary'" :type="'summary'"/> -->
            <VBUploadObjectsContinuousTable :tableData="table_data" :fields="fields" :objectName="'Row Data Summary'" :type="'summary'"/>
          </b-row>
          <b-row>
            <b-col>
              <span v-if = "warning_list.length > 0">
                <h3>Warnings:</h3>
                <VBUploadObjectsContinuousTable :tableData="warning_list" :objectName="'Warning'" :type="'warning'"/>

              </span>
              <!-- <div style="margin-bottom: 1rem; width:100%;">
                <h3 style="cursor: pointer;" @click="showObjectSummary = !showObjectSummary">
                  Object Summary:
                  <span v-if="showObjectSummary"> [-] </span>
                  <span v-else> [+] </span>
                </h3>
                <span v-if="showObjectSummary">
                  <VBUploadObjectsContinuousTable :tableData="publicationinfo_objs" :objectName="'Publication Info'" :type="'summary'"/>
                  <VBUploadObjectsContinuousTable :tableData="studymetadata_objs" :objectName="'Study Metadata'" :type="'summary'"/>
                  <VBUploadObjectsContinuousTable :tableData="taxonomy_objs" :objectName="'Taxonomy'" :type="'summary'"/>
                  <VBUploadObjectsContinuousTable :tableData="timeseriesdata_objs" :objectName="'Time Series Data'" :type="'summary'"/>
                  <div style="margin:5px;" v-if="!summaryObjectsExist" >
                    <h4>Uploaded file contains no new objects.</h4>
                  </div>
                </span>
              </div> -->
            </b-col>
          </b-row>
          <!-- END SUMMARIES -->
          <b-row class="mb-2">
            <b-col cols="12" class="mt-1 mb-4">
              <div style="float: right;" class="ml-1">
                <b-button @click="confirmCommit()" variant="success" block>
                  Commit File to Database
                </b-button>
              </div>
              <div style="float: right;" class="ml-1">
                <b-button @click="onReject()" variant="danger" block>Reject</b-button>
              </div>
              <div style="float: right;" class="ml-1">
                <b-button @click="onRollback()" variant="warning" block>Rollback</b-button>
              </div>
              <div style="float: right;" class="ml-1">
                <b-button class="button-link" :to="{name: 'curate-vecdyn'}" variant="primary" block>
                  Return to List
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </VDBaseTemplate>
  </template>
  
  <script>
  // @ is an alias to /src
  import { HTTP } from "@/utilities/http-common";
  import VDBaseTemplate from "@/layouts/VDBaseTemplate.vue";
  // import VBUploadObjectsTable from "@/components/tables/VBUploadObjectsTable.vue";
  import VBUploadObjectsContinuousTable from "@/components/tables/VBUploadObjectsContinuousTable.vue";
  import HandleErrors from "@/utilities/handle-errors";
  import { VECDYN_FILE_UPLOAD_DATA_TABLE_FIELDS } from "@/utilities/vecdyn-field-definitions";
  import _ from "lodash";
  import { mapState } from "vuex";
  
  export default {
      name: "vd-fileupload-detail",
      mixins: [VDBaseTemplate],
      components: {
        VDBaseTemplate,
        // VBUploadObjectsTable
        VBUploadObjectsContinuousTable
      },
      props: {
        id: String,
      },
      data(){
        return{
          table_data: [],
          // fields: [], // dynamically populated by buildFieldsArray()
          summary: {
            new_datasets: [],
            unknown_columns: [],
          },
          show_summary: false,
          file_name: '',
          file_url: '',
          status: '',
          uploader: '',
          notes: '',
          publicationinfo_objs: [],
          studymetadata_objs: [],
          taxonomy_objs: [],
          timeseriesdata_objs: [],
          summary_list: [],
          error_list: [],
          warning_list: [],
          err_msg: '',
          apiErrModalShow: false,
          workingModalShow: false,
          showObjectSummary: false,
          confirmCommitModalShow: false,
          confirmMessage: '',
          showFileModal: false,
          initialNotes: '',
          options: {
            currentPage: 1,
            totalRows: 0,
            perPage: 50
          },
          mapArray: undefined,
          mapDataAcquired: false,
          loading: false,
          consistent_data: {},
          componentKey: 0,
          downloadCSVModal: false,
          timeSeriesData: [],
          collectionChartDataByDate: {},
          chartSeriesArray: [],
          speciesChartArray: [],
          columnArrays: [],
          fieldDefDict: undefined,
          deleteDatasetModalShow: false,
          deleteWorkingModalShow: false,
          deleteConfirmed: null,
          deleteConfirmState: null,
          digitizedFromGraph: false,
          confirmRollbackModalShow: false,
          rollbackWorkingModalShow: false,
          // IMPORTANT: Field definitions are imported from a shared utility file
          // to maintain consistency across VecDyn components. 
          // 
          // To add/modify/remove fields:
          // 1. Edit src/utilities/vecdyn-field-definitions.js
          // 2. The changes will automatically apply to both:
          //    - VecDynFileUploadDetail.vue (this file)
          //    - SubmitVecdynData.vue
          // 
          // This ensures both components always have identical field definitions
          // and prevents maintenance issues from having duplicate field lists.
          // 
          // When adding new fields to the Django backend, remember to:
          // 1. Add the field to the Django model
          // 2. Run migrations
          // 3. Add the field to src/utilities/vecdyn-field-definitions.js
          // 4. Both Vue components will automatically pick up the changes
          fields: VECDYN_FILE_UPLOAD_DATA_TABLE_FIELDS
        };
      },
      created() {
        document.title = "Curate VecDyn File Upload Detail";
      },
      computed: {
        ...mapState("user", ["user", "myGroups"]),
        summaryObjectsExist: function () {
          // return true if there are any elements in any of the object lists
          let summaries = [
            this.publicationinfo_objs,
            this.studymetadata_objs,
            this.taxonomy_objs,
            this.timeseriesdata_objs,
          ]
          return summaries.some((array) => array.length != 0);
        },
        // cptItems(){
        //   // add formatting to the row items based on the value in the RowUploadStatus column
        //   return this.table_data.map((item)=>{
        //     let tmp=item;
        //     if (item.RowUploadStatus == "New row"){
        //       tmp._rowVariant='success';
        //     } else if (item.RowUploadStatus == "New row in existing dataset"){
        //       tmp._rowVariant='warning';
        //     } else if (item.RowUploadStatus == "Row already exists"){
        //       tmp._rowVariant='danger';
        //     }
        //     return tmp;
        //   })  
        // }
      },
      watch: {
      },
      mounted() {
        const that = this;
  
        this.workingModalShow = true;
  
        const fd = new FormData();
        fd.append("test", "test");
  
        HTTP.get(`/api/vecdyn-upload-detail/${this.id}/`, fd)
          .then(response => {
            that.table_data = response.data.records;
            // that.fields = this.buildFieldsArray(this.table_data);
            that.file_name = response.data.file_details.file_name;
            that.file_url = response.data.file_details.file;
            that.status = response.data.file_details.status;
            that.uploader = response.data.file_details.uploader;
            that.notes = response.data.file_details.notes;
            that.summary = response.data.summary;
            that.error_list = response.data.error_list;
            that.warning_list = response.data.warning_list;
            that.summary_list = response.data.summary_list;
            that.publicationinfo_objs = response.data.publicationinfo_list;
            that.studymetadata_objs = response.data.studymetadata_list;
            that.taxonomy_objs = response.data.taxonomy_list;
            that.timeseriesdata_objs = response.data.timeseriesdata_list;
            that.show_summary = true;
            that.workingModalShow = false;
            that.initialNotes = response.data.file_details.notes;
          })
          .catch((error) => {
            that.err_msg = HandleErrors.HandleErrors(error);
            that.apiErrModalShow = true;
            that.workingModalShow = false
          });
  
      },
      methods: {
        hideModal() {
          this.apiErrModalShow = false;
          this.downloadCSVModal = false;
        },
        hideConfirmCommitModal() {
          this.confirmCommitModalShow = false;
        },
        hideConfirmRollbackModal() {
          this.confirmRollbackModalShow = false;
        },
        buildFieldsArray(data) {
          // NOTE: IF THERE ARE NO ROWS IN DATA, THIS WILL ERROR OUT.
  
          // TODO: handle no rows in input. Currently, we are checking that there are rows before calling this
          // function in myProvider().
  
          // convert each element to an object containing the field name as a key, a sortable key, and tdclass:
          // ie. convert "OriginalID" to 
          // "{ key: 'OriginalID', sortable: true, tdClass: 'text-truncate vt-table-cell' },"
          let field_list = Object.keys(data[0]);
  
          let field_array = [];
  
          field_list.forEach(function(fieldName) {
              let field_dict = {};
              field_dict['key'] = fieldName;
              field_dict['sortable'] = true;
              field_dict['tdClass'] = 'text-truncate vt-table-cell';
              field_dict['__rowVariant'] = 'danger';
  
              field_array.push(field_dict);
          });
  
          return field_array;
        },
        updateNotes: function () {
          const fd = new FormData();
          fd.append("notes", this.notes);
  
          HTTP.put(`/api/vecdyn-uploads/${this.id}`, fd)
            .then(response => { 
              this.err_msg = response.data.err_msg;
              this.$notify({
                text: "Notes updated successfully!",
                duration: 10000,
                type: "success",
              });
            })
            // .catch((error) => {
            //   this.err_msg = HandleErrors.HandleErrors(error);
            //   this.apiErrModalShow = true;
            // });
            this.initialNotes = this.notes; // assign the newly updated notes
        },
        confirmCommit: function () {
          this.confirmMessage = 'Are you sure you would like to commit this file to the database?';
          this.confirmCommitModalShow = true;
        },
        onCommit: function () {
            const fd = new FormData();
            fd.append("uploaded_file_id", this.id);
            fd.append("notes", this.notes);
            HTTP.post("/api/vecdyn-commit/", fd)
              .then(response => { 
                this.err_msg = response.data.err_msg;
                this.$notify({
                  text: "File committed successfully!",
                  duration: 10000,
                  type: "success",
                });
              })
              // .catch((error) => {
              //   this.err_msg = HandleErrors.HandleErrors(error);
              //   this.apiErrModalShow = true;
              // });
        },
        onReject: function () {
            const fd = new FormData();
            fd.append("uploaded_file_id", this.id);
            fd.append("notes", this.notes);
            HTTP.post("/api/vecdyn-reject/", fd)
              .then(response => { 
                this.err_msg = response.data.err_msg;
                this.$notify({
                  text: "File rejected successfully!",
                  duration: 10000,
                  type: "success",
                });
              })
              // .catch((error) => {
              //   this.err_msg = HandleErrors.HandleErrors(error);
              //   this.apiErrModalShow = true;
              // });
        },
        onRollback: function(){
          this.confirmRollbackModalShow = true;
        },
        executeRollback: function() {
          this.rollbackWorkingModalShow = true;
          const fd = new FormData();
          fd.append("file_id", this.id);
          HTTP.post("/api/vecdyn-rollback-file-upload/", fd)
            .then(response => {
              this.rollbackWorkingModalShow = false;
              this.$notify({
                text: response.data.message || "Rollback completed successfully!",
                duration: 10000,
                type: "success",
              });
              this.fetchFileDetails();
            })
            .catch(error => {
              this.rollbackWorkingModalShow = false;
              this.err_msg = HandleErrors.HandleErrors(error);
              this.apiErrModalShow = true;
            });
        },
        fetchFileDetails() {
          const that = this;
          HTTP.get(`/api/vecdyn-upload-detail/${this.id}/`)
            .then(response => {
              that.file_name = response.data.file_details.file_name;
              that.file_url = response.data.file_details.file;
              that.status = response.data.file_details.status;
              that.uploader = response.data.file_details.uploader;
              that.notes = response.data.file_details.notes;
              that.summary = response.data.summary;
              that.error_list = response.data.error_list;
              that.warning_list = response.data.warning_list;
              that.summary_list = response.data.summary_list;
              that.publicationinfo_objs = response.data.publicationinfo_list;
              that.studymetadata_objs = response.data.studymetadata_list;
              that.taxonomy_objs = response.data.taxonomy_list;
              that.timeseriesdata_objs = response.data.timeseriesdata_list;
              that.show_summary = true;
            })
            .catch((error) => {
              that.err_msg = HandleErrors.HandleErrors(error);
              that.apiErrModalShow = true;
            });
        },
        downloadFile(){
          // build the params object to be sent with the request.
          var params = new URLSearchParams();
          // params.append(<KEY>, <VALUE>)
  
          var request = {
              params: params,
              responseType: "arraybuffer",
          };
  
          HTTP.get(this.file_url, request)
            .then((response) => {
                var fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                var fileLink = document.createElement("a");
                fileLink.href = fileURL;
                var fileName = this.file_name;
                fileLink.setAttribute("download", fileName);
                document.body.appendChild(fileLink);
                fileLink.click();
            })
            // .catch((error) => { // executes whenever there is a response that is not a 200
            //   this.err_msg = HandleErrors.HandleErrors(error);
            //   this.apiErrModalShow = true;
            // });
        },
        downloadCSV: function (items, title) {
          var columns = _.keys(items[0]);
          var csv = columns.join(",") + "\n";
          items.forEach(function (row) {
            csv += _.values(row).join(",");
            csv += "\n";
          });

          var hiddenElement = document.createElement("a");
          hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
          hiddenElement.target = "_blank";
          hiddenElement.download = title + ".csv";
          hiddenElement.click();
        },
      },
  };
  </script>
  
  <style scoped>
  .button-link {
    color: white !important;
  }
    
  </style>